import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { FB_COLLECTION_PATH } from "./postActionTypes";

export interface JobChatMessageInfo {
  senderUID: string;
  chatId: string;
  message: string;
  clientId: string;
  senderFirstName: string;
  senderLastName: string;
  senderPicURL: string;
  chatPreviewPicURL: string;
  jobName: string;
  timestamp: number;
}

export async function fx_FB_JobChatMessagePending(info: JobChatMessageInfo): Promise<void> {
  const pendingRef = doc(
    db,
    FB_COLLECTION_PATH.Users,
    info.senderUID,
    "jobChatMessagePending",
    info.clientId
  );
  await setDoc(pendingRef, { chatMessageInfo: info });
}
